export default function selectLinkedSection(pages, sectionId, thisSectionData) {

  if (!pages) return thisSectionData;

  for (let i = 0; i < pages.length; i++) {
    if (pages[i].sectionId === sectionId) return pages[i];
  }

  return thisSectionData;


}